import * as yup from 'yup';

yup.setLocale({
  mixed: {
    required: 'fieldRequired',
  },
});

yup.addMethod(yup.mixed, 'stripForApiRequest', function () {
  return this.when('$type', (type, schema) =>
    type === 'apiRequest' ? schema.strip() : schema,
  );
});

export default yup;
